import React, { lazy, useEffect, useRef, useState } from "react";
import { AccountDetails, PaymentOptions, StoreProps } from "./Payment.types";
import { getDepositPaymentMethodLabel } from "../../../utils/paymentLangMapping";
import {
  useAppSelector,
  HOME_ROUTE,
  MY_TRANSACTION_ROUTE,
  useAppDispatch,
  showToast,
  ButtonVariable,
  AvailablePaymentGateways,
  demoUser,
  createApiClient,
  AGPAY_ACTIONS,
  agpayUrl,
  matchesQueueSource,
  PAYMENT_METHOD_KEYS,
  resolveGatewayAlias,
  PAYMENT_OPTION,
  toProviderPath,
  toQueueSource,
  toBonusPolicyPaymentMethod,
  TX_TYPE,
  ZENPAY_REDIRECT_PROVIDERS,
} from "@hypexone/uicore";
import { useNavigate } from "react-router-dom";
import Paytring from "./DepositTabPanels/Paytring";
import PaymentClient from "@hypexone/uicore/lib/cjs/src/client/payment/payment_client";
import CommonClient from "@hypexone/uicore/lib/cjs/src/client/reddog/common_client";
import { BRAND_DOMAIN } from "../../../constants/Branding";
import { normalizeInput } from "./commonutils";
import Button from "../../components/shared/Button/Button";
import { errorHandler } from "../../../App.utils";
import { getBaseUrl } from "../../../api/api-services/environment-url/environment-url";

const Pgman = lazy(() => import("./DepositTabPanels/Pgman"));
const ZenPay = lazy(() => import("./DepositTabPanels/Zenpay"));
const ZenpayCrypto = lazy(() => import("./DepositTabPanels/ZenpayCrypto"));
const ZenpayCryptoSeamless = lazy(() => import("./DepositTabPanels/ZenpayCryptoSeamless"));

export type BonusDto = {
  id: number;
  name: string;
  description: string;
  bonusCategory: string;
};

const paymentOptionMap: Map<string, string> = new Map([
  ["UPI", "UPI"],
  ["GPAY", "UPI"],
  ["PHONEPE", "UPI"],
  ["BANK_TRANSFER", "IMPS"],
  ["CRYPTO_WALLET_TRANSFER", "CRYPTO_WALLET"],
]);

const Deposit: React.FC<StoreProps> = (props) => {
  const { setOpenDepositModal } = props;
  const [tabValue, setTabValue] = useState<number>(0);
  const [paymentOption, setPaymentOption] = useState<string>(PAYMENT_METHOD_KEYS.UPI);
  const [accountDetails, setAccountDetails] = useState<AccountDetails[]>();
  const [selectedAccountId, setSelectedAccountId] = useState<string>();
  const [depositAmount, setDepositAmount] = useState<string>();
  const [depositNotes, setDepositNotes] = useState<string>();
  const [referenceId, setReferenceId] = useState<string>();
  const [depositImage, setDepositImage] = useState<string | ArrayBuffer>();
  const [loading, setLoading] = useState<boolean>(false);
  const [onlinePaymentOption, setOnlinePaymentOption] = useState<string>(PAYMENT_METHOD_KEYS.UPI);
  const [mobileNumber, setMobileNumber] = useState<string>();
  const [paymentDetails, setPaymentDetails] = useState<PaymentOptions[]>();
  const [providerRefId, setProviderRefId] = useState<string>();
  const [providersList, setProvidersList] = useState([]);
  const [depositPaymentMethodsInfo, setDepositPaymentMethodsInfo] =
    useState<any>([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [paymentOptionFilter, setPaymentOptionFilter] =
    useState<string>("IMPS");
  const [ocrDepositAmount, setOcrDepositAmount] = useState<string>();
  const [ocrReferenceId, setOcrReferenceId] = useState<string>();
  const hiddenFileInput = useRef(null);
  const [uploadImage, setUploadImage] = useState(null);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const { domainConfig, whatsappDetails } = useAppSelector((state) => state.common);
  const navigate = useNavigate();


  const { langData } = useAppSelector((state) => state.cms);
  const dispatch = useAppDispatch();

  const [selectedPaymentMethod, setSelectedpaymentMethod] = useState("");

  //   const paymentImagesMap = {
  //     "BANK_TRANSFER" : BANK_TRANSFER,
  //     "UPI" : UPI_OPTIONS,
  //     "IMPS" : IMPS,
  //     "WALLET" : DIGITAL_WALLET
  //   }

  const successToast = (mess: string) => {
    dispatch(
      showToast({
        type: "success",
        message: mess,
      })
    );
  };

  const AGPAY_BASE_URL = getBaseUrl(
    import.meta.env.VITE_NODE_ENV,
    "REACT_APP_REST_AGPAY_URL"
  );

  const AGPAY_API_CLIENT = createApiClient(
    AGPAY_BASE_URL,
    sessionStorage.getItem("jwt_token"),
    errorHandler
  );
  
  const paymentClient = new PaymentClient(
    AGPAY_BASE_URL,
    sessionStorage.getItem("jwt_token"),
    errorHandler
  );

  const SVLS_BASE_URL = getBaseUrl(
    import.meta.env.VITE_NODE_ENV,
    "REACT_APP_REST_API_V2_URL"
  );

  const commonClient = new CommonClient(
    SVLS_BASE_URL,
    sessionStorage.getItem("jwt_token"),
    errorHandler
  );

  const [showWhatsapp, setShowWhatsapp] = useState<boolean>(true);
  const [selectedBonus, setSelectedBonus] = useState<string>();
  const [bonusTypes, setBonusTypes] = useState<BonusDto[]>();
  const [showBonusSelection, setShowBonusSelection] = useState<boolean>(false);
  const [pendingPaymentType, setPendingPaymentType] = useState<string>("");

  // const getAdminWhatsAppNumber = () => {
  //     window.open(whatsappDetails, '_blank')
  // };

  const errorToast = (mess: string) => {
    dispatch(
      showToast({
        type: "error",
        message: mess ?? "",
      })
    );
  };

  const getImageDetails = async () => {
    setLoading(true);
    setDepositAmount("");
    setOcrDepositAmount("");
    setReferenceId("");
    setOcrReferenceId("");
    try {
      const response = await paymentClient.getTxnImageDetails(
        paymentOption,
        paymentOptionFilter,
        depositImage
      );

      if (response.status === 200 && response?.data) {
        const data = response.data;
        const amount = data.amount.trim();
        const utr = data.utr.trim();

        setDepositAmount(amount);
        setOcrDepositAmount(amount);
        setReferenceId(utr);
        setOcrReferenceId(utr);

        if (amount === "" || utr === "") {
          errorToast(langData?.['enter_details_manually_txt']);
        } else {
          successToast(langData?.['details_entered_success_txt']);
        }
      } else {
        errorToast(langData?.['general_err_txt']);
      }

      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const getUtr = async () => {
    setLoading(true);
    setReferenceId("");
    setOcrReferenceId("");
    try {
      const response = await paymentClient.getUtrDetails(
        paymentOption,
        paymentOptionFilter,
        depositImage
      );

      if (response.status === 200 && response?.data) {
        var utr = response.data;
        setReferenceId(utr);
        setOcrReferenceId(utr);
        if (utr === "") {
          errorToast(langData?.['enter_details_manually_txt']);
        } else {
          successToast(langData?.['utr_entered_success_txt']);
        }
      } else {
        errorToast(langData?.['general_err_txt']);
      }

      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      depositImage !== undefined &&
      depositImage !== null &&
      depositImage !== ""
    ) {
      if (tabValue === 1) {
        // getImageDetails();
      } else if (tabValue === 0) {
        // getUtr();
      }
    }
  }, [depositImage]);

  const fetchPaymentMethod = async () => {
    try {
      const response = await paymentClient.getPaymentMethods(
        paymentOptionMap,
        paymentOption
      );

      if (response.status === 200) {
        let accountsArr = [];
        response.data?.map((i) => {
          if (!i?.disabled) accountsArr.push(i);
        });
        setAccountDetails(accountsArr);
        const initialSelectedAccount = accountsArr[0];
        setSelectedAccount(initialSelectedAccount);
        setSelectedAccountId(initialSelectedAccount?.id?.toString());
      } else {
      }
    } catch (error) { }
  };

  const getPaymentProviders = async () => {
    setLoading(true);
    try {
      const response = await paymentClient.getPaymentProviders();

      if (response.status === 200) {
        const depositMethods = response?.data?.filMethod;
        setDepositPaymentMethodsInfo(depositMethods);
        if (depositMethods?.[PAYMENT_METHOD_KEYS.BANK_TRANSFER]) {
          setSelectedpaymentMethod(PAYMENT_METHOD_KEYS.BANK_TRANSFER);
          setPaymentOption(PAYMENT_METHOD_KEYS.BANK_TRANSFER);
          setProvidersList(depositMethods[PAYMENT_METHOD_KEYS.BANK_TRANSFER]);
          setOnlinePaymentOption(PAYMENT_METHOD_KEYS.BANK_TRANSFER);
        } else if (depositMethods?.[PAYMENT_METHOD_KEYS.UPI]) {
          setSelectedpaymentMethod(PAYMENT_METHOD_KEYS.UPI);
          setPaymentOption(PAYMENT_METHOD_KEYS.UPI);
          setProvidersList(depositMethods[PAYMENT_METHOD_KEYS.UPI]);
          setOnlinePaymentOption(PAYMENT_METHOD_KEYS.UPI);
        } else if (depositMethods?.[PAYMENT_METHOD_KEYS.CRYPTO_WALLET_TRANSFER]) {
          setSelectedpaymentMethod(PAYMENT_METHOD_KEYS.CRYPTO_WALLET_TRANSFER);
          setPaymentOption(PAYMENT_METHOD_KEYS.CRYPTO_WALLET_TRANSFER);
          setProvidersList(depositMethods[PAYMENT_METHOD_KEYS.CRYPTO_WALLET_TRANSFER]);
          setOnlinePaymentOption(PAYMENT_METHOD_KEYS.CRYPTO_WALLET_TRANSFER);
        }
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    // setPaymentGatewaysCount(0);
    // getPaymentProviders();
    if (paymentOption === "NEFT") {
      // fetchPaymentMethod();
    }
    setDepositNotes("");
    setDepositAmount("");
    // setAccountDetails([]);
    setSelectedAccountId("");
    // setOnlinePaymentOption('UPI');
    setPaymentOptionFilter("IMPS");
    // setBonusTypes([]);
    setShowBonusSelection(false);
    setPendingPaymentType("");
  }, [tabValue]);

  const submitPayment = async (e) => {
    e.preventDefault();
    if (!depositImage) {
      errorToast(langData?.['upload_txn_img_txt']);
      return false;
    } else if (Number(depositAmount) < 100) {
      errorToast(langData?.['min_deposit_amount_txt']);
      return false;
    }
    setLoading(true);
    try {
      const payload = {
        amount: Number(depositAmount),
        notes: depositNotes,
        reference_id: referenceId,
        queue_source_id: selectedAccountId,
        payment_option:
          paymentOption === "NEFT"
            ? paymentOptionFilter
            : paymentOption === PAYMENT_METHOD_KEYS.UPI
              ? "UPI"
              : "PAYTM_WALLET",
        amount_modified: ocrDepositAmount !== depositAmount,
        reference_id_modified: ocrReferenceId !== referenceId,
        bonus_policy_id: selectedBonus != '-' ? selectedBonus : null,
      };
      let formData = new FormData();
      formData.append("paymentSlip", uploadImage);
      formData.append("request", JSON.stringify(payload));
      const response = await AGPAY_API_CLIENT.post(
        agpayUrl('hfman', 'yuri', AGPAY_ACTIONS.DEPOSIT),
        formData,
        {
          headers: {
            Authorization: sessionStorage.getItem("jwt_token"),
            "Content-Type": "multipart/form-data"
          },
        }
      );

      if (response.status === 204) {
        successToast(langData?.['txn_saved_success_txt']);
        window.location.href = MY_TRANSACTION_ROUTE;
        setOpenDepositModal(false);
      } else {
        errorToast(response?.data?.message);
      }
      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const handleCapture = ({ target }) => {
    const file = target.files[0];
    if (file.size > 5 * 1024 * 1024) {
      errorToast('File upload error: The file size must be less than 5MB');
      target.value = '';
      setUploadImage(null);
      setDepositImage(null);
      return;
    }
    setUploadImage(file);
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (e) => {
      setDepositImage(e.target.result);
    };
  };
  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const getBonusTypes = async (amount: number, paymentMethod: string = onlinePaymentOption) => {
    try {
      const response = await commonClient.fetchBonusTypes(amount, toBonusPolicyPaymentMethod(paymentMethod));
      if (response.status == 200) {
        const noBonus: BonusDto = {
          id: null,
          name: "-",
          description: "",
          bonusCategory: "",
        };
        setBonusTypes([noBonus, ...response.data]);
        if (response.data && response.data?.length > 0) {
          setSelectedBonus(response.data[0]?.id);
        }
      }
      return response.data;
    } catch (error) {
      errorToast(error?.response?.data?.message);
    }
  };

  const submitOnlineAmount = async (e, type = "abcmoney") => {
    e.preventDefault();
    if (Number(depositAmount) < 100) {
      errorToast(langData?.['min_deposit_amount_txt']);
      return false;
    }
    setLoading(true);

    try {
      // Check if type is zenpayredirect, zenpayredirect1, or zenpayredirect2
      if (type === "jpredirect" || type === "jpredirect1" || type === "jpredirect2") {
        await getBonusTypes(Number(depositAmount));
        setShowBonusSelection(true);
        setPendingPaymentType(type);
        setLoading(false);
        return;
      }
      const payload = {
        amount: Number(depositAmount),
        cr_type: "INR",
        mobile_number: mobileNumber ? mobileNumber : "9876543211",
        notes: depositNotes,
        queue_source: toQueueSource(onlinePaymentOption),
        qri: onlinePaymentOption === PAYMENT_METHOD_KEYS.UPI,
        qrr: onlinePaymentOption === PAYMENT_METHOD_KEYS.UPI,
        return_url: window.location.origin + "/my_transactions",
      };
      // if (type == "jp") {
      //   getBonusTypes(Number(depositAmount));
      // }
      getBonusTypes(Number(depositAmount));
      const response = await paymentClient.submitDepositTransactions(
        type,
        payload
      );

      if (response.status === 200) {
        if (response.data.queue_options?.length > 0) {
          setPaymentDetails(response.data.queue_options);
          setProviderRefId(response.data.provider_ref_id);
        }
        successToast(langData?.['txn_saved_success_txt']);
      }
      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };



  const proceedWithPayment = async (e, type = "abcmoney") => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        amount: Number(depositAmount),
        cr_type: "INR",
        mobile_number: mobileNumber ? mobileNumber : "9876543211",
        notes: depositNotes,
        queue_source: toQueueSource(onlinePaymentOption),
        qri: onlinePaymentOption === PAYMENT_METHOD_KEYS.UPI,
        qrr: onlinePaymentOption === PAYMENT_METHOD_KEYS.UPI,
        return_url: window.location.origin + "/my_transactions",
        bonus_policy_id: selectedBonus != "-" ? selectedBonus : null,
      };

      const response = await paymentClient.submitDepositTransactions(type, payload);

      if (response.status === 200) {
        setShowBonusSelection(false);
        if (response.data.queue_options?.length > 0) {
          let upiPaymentOption = response.data.queue_options[0];
          if (upiPaymentOption?.sessionUrl) {
            const shouldOpenInNewTab = upiPaymentOption?.newTab === true;
            if (shouldOpenInNewTab) {
              window.open(upiPaymentOption.sessionUrl, "_blank");
            } else {
              window.location.href = upiPaymentOption.sessionUrl;
            }
            return;
          } else if (upiPaymentOption?.paymentLink) {
            const shouldOpenInNewTab = upiPaymentOption?.newTab === true;
            if (shouldOpenInNewTab) {
              window.open(upiPaymentOption.paymentLink, "_blank");
            } else {
              window.location.href = upiPaymentOption.paymentLink;
            }
            return;
          } else if (
            upiPaymentOption?.queue_source_details &&
            upiPaymentOption?.queue_source_details?.paymentLink
          ) {
            const shouldOpenInNewTab =
              upiPaymentOption?.queue_source_details?.newTab === true;
            if (shouldOpenInNewTab) {
              window.open(
                upiPaymentOption.queue_source_details.paymentLink,
                "_blank"
              );
            } else {
              window.location.href =
                upiPaymentOption.queue_source_details.paymentLink;
            }
            return;
          }
        }
        successToast(langData?.["txn_saved_success_txt"]);
      }
      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const confirmPayment = async (e, selectedPaymentGateway = "abcmoney") => {
    e.preventDefault();
    const UPI_REGEX = /^[0-9]{12}$/;
    const RTGS_REGEX = /^[A-Z]{4}R[1-6][0-9]{2}[0-9]{8}[0-9]{8}$/;
    const NEFT_REGEX = /^[A-Z]{4}[NH][0-9]{2}[0-9]{3}[0-9]{6}$/;

    if (!depositImage) {
      errorToast('Please Upload Transaction Image');
      return false;
    }
    if (
      !(
        UPI_REGEX.test(referenceId) ||
        RTGS_REGEX.test(referenceId) ||
        NEFT_REGEX.test(referenceId)
      )
    ) {
      errorToast('Invalid UTR provided');
      return false;
    }
    setLoading(true);

    try {
      const payload = {
        gateway_provider_reference_id: providerRefId,
        utr: normalizeInput(referenceId),
        mobile_number: mobileNumber ? mobileNumber : "9876543211",
        bank_id: paymentDetails?.filter((i) =>
          matchesQueueSource(i?.queue_source, onlinePaymentOption)
        )[0].queue_source_details?.bid,
        payment_option:
          onlinePaymentOption === PAYMENT_METHOD_KEYS.BANK_TRANSFER ? "IMPS" : "UPI",
        reference_id_modified: ocrReferenceId !== referenceId,
        upi_intent: !!paymentDetails?.filter((i) =>
          matchesQueueSource(i?.queue_source, onlinePaymentOption)
        )[0]?.queue_source_details?.qri,
        bonus_policy_id: selectedBonus != '-' ? selectedBonus : null,
      };
      let formData = new FormData();
      formData.append("paymentSlip", uploadImage);
      formData.append("request", JSON.stringify(payload));
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      const response = await AGPAY_API_CLIENT.post(
        agpayUrl(toProviderPath(selectedPaymentGateway), AGPAY_ACTIONS.CONFIRM_PAYMENT),
        formData,
        {
          headers: {
            'Content-Type': `multipart/form-data`,
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status == 200) {
        successToast(langData?.['txn_saved_success_txt']);
        window.location.href = MY_TRANSACTION_ROUTE;
        // setOpenDepositModal(false);
      }
      setLoading(false);
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  let buttonVariables: ButtonVariable[] = [
    { label: '500', stake: 500 },
    { label: '1000', stake: 1000 },
    { label: '5000', stake: 5000 },
    { label: '10000', stake: 10000 },
    { label: '25000', stake: 25000 },
    { label: '50000', stake: 50000 },
    { label: '100000', stake: 100000 },
    { label: '500000', stake: 500000 },
    { label: '1000000', stake: 1000000 },
  ];

  const copyText = (text, toastMessage = langData?.['text_copied_txt']) => {
    navigator.clipboard.writeText(text);
    successToast(toastMessage);
  };

  useEffect(() => {
    if (paymentOption) {
      // fetchPaymentMethod();
      setAccountDetails([]);
      setSelectedAccountId("");
      setDepositAmount("");
      setDepositImage("");
      setDepositNotes("");
      setReferenceId("");
      setShowBonusSelection(false);
      setPendingPaymentType("");
    }
  }, [paymentOption]);

  useEffect(() => {
    setPaymentDetails([]);
    setDepositAmount("");
    setDepositNotes("");
    setReferenceId("");
    setMobileNumber("");
    setProviderRefId("");
    setShowBonusSelection(false);
    setPendingPaymentType("");
  }, [onlinePaymentOption, tabValue]);

  const demoUserWhatsappDetails =
    domainConfig?.suppportContacts?.find(
      (ct) => ct?.contactType === "REGISTRATION_WHATSAPP_LINK"
    )?.details || null;

  const getAdminWhatsAppNumber = () => {
    window.open(demoUser() ? demoUserWhatsappDetails : whatsappDetails, '_blank')
  };

  const submitPaytring = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        queue_source: "UPT",
        amount: Number(depositAmount),
        cname: sessionStorage.getItem("username"),
        phone: "9876543211",
        email: "johnny@email.com",
        callback_url: window.location.origin + "/transactions/my_transactions",
        bonus_policy_id: selectedBonus != '-' ? selectedBonus : null,
      };
      const response = await paymentClient.submitDepositTransactions(
        "paytring",
        payload
      );

      setLoading(false);
      if (response.status == 200 && response.data.url) {
        window.location.href = atob(response.data.url);
        successToast(langData?.['txn_saved_success_txt']);
      } else {
        errorToast(langData?.['general_err_txt']);
      }
    } catch (error) {
      errorToast(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const renderPaymentForm = (
    paymentGateway: string,
    index: number,
    tabValue: number
  ) => {
    switch (resolveGatewayAlias(paymentGateway)) {
      case AvailablePaymentGateways.PGMAN:
        return (
          <Pgman
            index={index}
            tabValue={tabValue}
            paymentOption={paymentOption}
            setPaymentOption={setPaymentOption}
            accountDetails={accountDetails}
            selectedAccountId={selectedAccountId}
            setSelectedAccountId={setSelectedAccountId}
            setSelectedAccount={setSelectedAccount}
            selectedAccount={selectedAccount}
            copyText={copyText}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            submitPayment={submitPayment}
            depositAmount={depositAmount}
            depositNotes={depositNotes}
            referenceId={referenceId}
            setDepositAmount={setDepositAmount}
            setDepositNotes={setDepositNotes}
            setReferenceId={setReferenceId}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            loading={loading}
            ref={hiddenFileInput}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            onlinePaymentOption={onlinePaymentOption}
            bonusTypes={bonusTypes}
            setBonusTypes={setBonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            getBonusTypes={getBonusTypes}
            showDetailsForm={showDetailsForm}
            setShowDetailsForm={setShowDetailsForm}
          />
        );
      case AvailablePaymentGateways.ZENPAY:
        return (
          <ZenPay
            index={index}
            providersList={providersList}
            onlinePaymentOption={onlinePaymentOption}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            submitOnlineAmount={submitOnlineAmount}
            paymentDetails={paymentDetails}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            loading={loading}
            providerRefId={providerRefId}
            confirmPayment={confirmPayment}
            copyText={copyText}
            referenceId={referenceId}
            setReferenceId={setReferenceId}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            setShowWhatsapp={setShowWhatsapp}
            showWhatsapp={showWhatsapp}
            bonusTypes={bonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            pgProvider="jp"
            showBonusSelection={showBonusSelection}
            setShowBonusSelection={setShowBonusSelection}
            proceedWithPayment={proceedWithPayment}
            pendingPaymentType={pendingPaymentType}
          />
        );
      case AvailablePaymentGateways.ZENPAY1:
        return (
          <ZenPay
            index={index}
            providersList={providersList}
            onlinePaymentOption={onlinePaymentOption}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            submitOnlineAmount={submitOnlineAmount}
            paymentDetails={paymentDetails}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            loading={loading}
            providerRefId={providerRefId}
            confirmPayment={confirmPayment}
            copyText={copyText}
            referenceId={referenceId}
            setReferenceId={setReferenceId}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            setShowWhatsapp={setShowWhatsapp}
            showWhatsapp={showWhatsapp}
            bonusTypes={bonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            pgProvider="jp1"
            showBonusSelection={showBonusSelection}
            setShowBonusSelection={setShowBonusSelection}
            proceedWithPayment={proceedWithPayment}
            pendingPaymentType={pendingPaymentType}
          />
        );
      case AvailablePaymentGateways.ZENPAY2:
        return (
          <ZenPay
            index={index}
            providersList={providersList}
            onlinePaymentOption={onlinePaymentOption}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            submitOnlineAmount={submitOnlineAmount}
            paymentDetails={paymentDetails}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            loading={loading}
            providerRefId={providerRefId}
            confirmPayment={confirmPayment}
            copyText={copyText}
            referenceId={referenceId}
            setReferenceId={setReferenceId}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            setShowWhatsapp={setShowWhatsapp}
            showWhatsapp={showWhatsapp}
            bonusTypes={bonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            pgProvider="jp2"
            showBonusSelection={showBonusSelection}
            setShowBonusSelection={setShowBonusSelection}
            proceedWithPayment={proceedWithPayment}
            pendingPaymentType={pendingPaymentType}
          />
        );
      
case AvailablePaymentGateways.ZENPAYREDIRECT:
        return (
          <ZenPay
            index={index}
            providersList={providersList}
            onlinePaymentOption={onlinePaymentOption}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            submitOnlineAmount={submitOnlineAmount}
            paymentDetails={paymentDetails}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            loading={loading}
            providerRefId={providerRefId}
            confirmPayment={confirmPayment}
            copyText={copyText}
            referenceId={referenceId}
            setReferenceId={setReferenceId}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            setShowWhatsapp={setShowWhatsapp}
            showWhatsapp={showWhatsapp}
            bonusTypes={bonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            pgProvider="jpredirect"
            showBonusSelection={showBonusSelection}
            setShowBonusSelection={setShowBonusSelection}
            proceedWithPayment={proceedWithPayment}
            pendingPaymentType={pendingPaymentType}
          />
        );
      case AvailablePaymentGateways.ZENPAYREDIRECT1:
        return (
          <ZenPay
            index={index}
            providersList={providersList}
            onlinePaymentOption={onlinePaymentOption}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            submitOnlineAmount={submitOnlineAmount}
            paymentDetails={paymentDetails}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            loading={loading}
            providerRefId={providerRefId}
            confirmPayment={confirmPayment}
            copyText={copyText}
            referenceId={referenceId}
            setReferenceId={setReferenceId}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            setShowWhatsapp={setShowWhatsapp}
            showWhatsapp={showWhatsapp}
            bonusTypes={bonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            pgProvider="jpredirect1"
            showBonusSelection={showBonusSelection}
            setShowBonusSelection={setShowBonusSelection}
            proceedWithPayment={proceedWithPayment}
            pendingPaymentType={pendingPaymentType}
          />
        );
      case AvailablePaymentGateways.ZENPAYREDIRECT2:
        return (
          <ZenPay
            index={index}
            providersList={providersList}
            onlinePaymentOption={onlinePaymentOption}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            submitOnlineAmount={submitOnlineAmount}
            paymentDetails={paymentDetails}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            loading={loading}
            providerRefId={providerRefId}
            confirmPayment={confirmPayment}
            copyText={copyText}
            referenceId={referenceId}
            setReferenceId={setReferenceId}
            paymentOptionFilter={paymentOptionFilter}
            setPaymentOptionFilter={setPaymentOptionFilter}
            depositImage={depositImage}
            handleCapture={handleCapture}
            handleClick={handleClick}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            setShowWhatsapp={setShowWhatsapp}
            showWhatsapp={showWhatsapp}
            bonusTypes={bonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            pgProvider="jpredirect2"
            showBonusSelection={showBonusSelection}
            setShowBonusSelection={setShowBonusSelection}
            proceedWithPayment={proceedWithPayment}
            pendingPaymentType={pendingPaymentType}
          />
        );
      case AvailablePaymentGateways.ZENPAYCRYPTO:
        return (
          <ZenpayCrypto
            setOpenDepositModal={setOpenDepositModal}
            setLoading={setLoading}
            index={index}
            providersList={providersList}
            onlinePaymentOption={onlinePaymentOption}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            loading={loading}
            copyText={copyText}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            setShowWhatsapp={setShowWhatsapp}
            showWhatsapp={showWhatsapp}
            bonusTypes={bonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            getBonusTypes={getBonusTypes}
            depositImage={depositImage}
            handleClick={handleClick}
            handleCapture={handleCapture}
            uploadImage={uploadImage}
          />
        );
      case AvailablePaymentGateways.ZENPAYCRYPTOSEAMLESS:
        return (
          <ZenpayCryptoSeamless
            index={index}
            providersList={providersList}
            depositPaymentMethodsInfo={depositPaymentMethodsInfo}
            setOnlinePaymentOption={setOnlinePaymentOption}
            tabValue={tabValue}
            copyText={copyText}
            ref={hiddenFileInput}
            getAdminWhatsAppNumber={getAdminWhatsAppNumber}
            showWhatsapp={showWhatsapp}
          />
        );
      case AvailablePaymentGateways.PAYTRING:
        return (
          <Paytring
            index={index}
            providersList={providersList}
            tabValue={tabValue}
            submitPaytring={submitPaytring}
            depositAmount={depositAmount}
            setDepositAmount={setDepositAmount}
            loading={loading}
            ref={hiddenFileInput}
            buttonVariables={buttonVariables}
            bonusTypes={bonusTypes}
            setBonusTypes={setBonusTypes}
            selectedBonus={selectedBonus}
            setSelectedBonus={setSelectedBonus}
            getBonusTypes={getBonusTypes}
          />
        );
      default:
        return null;
    }
  };

  // const getPaymentIcon = (method) => {
  //     return method === 'GPAY'
  //         ? gpay
  //         : method === 'PHONEPE'
  //             ? phonePe
  //             : method === 'BANK_TRANSFER'
  //                 ? bank
  //                 : method === 'PAYTM'
  //                     ? paytm
  //                     : null;
  // };

  useEffect(() => {
    if (depositPaymentMethodsInfo && selectedPaymentMethod) {
      setProvidersList(depositPaymentMethodsInfo[selectedPaymentMethod] || []);
    }
  }, [depositPaymentMethodsInfo, selectedPaymentMethod]);

  useEffect(() => {
    getPaymentProviders();
  }, []);

  useEffect(() => {
    if (!domainConfig.payments) {
      navigate(HOME_ROUTE, { replace: true });
    }
  }, []);

  return (
    <section className="flex flex-col items-start pb-44 bg-white rounded border border-solid border-black border-opacity-10 max-md:pb-24 md:p-0">
      <header className="self-stretch px-4 py-1.5 text-lg max-md:text-[18px] max-md:py-1 text-white rounded bg-section-gradient max-md:pr-5 max-md:max-w-full">
        {langData?.['deposit_amount']}
      </header>

      <div className=" p-3 max-md:w-full max-md:py-2 max-md:px-0 ">
        <div className="flex items-center text-base leading-none text-black w-full md:w-[400px] cursor-pointer">
          {depositPaymentMethodsInfo &&
            Object.keys(depositPaymentMethodsInfo).map(
              (paymentMethodName, index) => {
                return (
                  <div
                    key={index}
                    className={`gap-2.5 self-stretch px-4 py-2  ${selectedPaymentMethod === paymentMethodName
                        ? "bg-blue-950 text-white"
                        : "bg-stone-300 border-r border-blue-950"
                      }`}
                    onClick={() => {
                      setBonusTypes([]);
                      setShowDetailsForm(false);
                      setTabValue(0);
                      setSelectedpaymentMethod(paymentMethodName);
                      setPaymentOption(paymentMethodName);
                      setProvidersList(
                        depositPaymentMethodsInfo[paymentMethodName]
                      );
                      setPaymentDetails([]);
                      setProviderRefId("");
                      setOnlinePaymentOption(paymentMethodName);
                    }}
                  >
                    <div className="text-center text-sm font-medium">
                      {getDepositPaymentMethodLabel(paymentMethodName, langData)}
                    </div>
                  </div>
                );
              }
            )}

          {
            whatsappDetails && BRAND_DOMAIN != 'crypto247.club' && (
              <Button onClick={getAdminWhatsAppNumber} className="flex justify-start items-center animate-blink_deposit text-white text-xs w-fit relative border border-black gap-2.5 px-4 py-2 text-nowrap">
                {langData?.['whatsapp_deposit']}
              </Button>
            )
          }
        </div>
        {
          demoUser() && (
            <div className="text-xs animate-pulse text-yellow mb-4">
              {
                langData?.["demo_deposits_msg"]
              }
            </div>
          )
        }
        <div className="text-xs animate-pulse text-red-500">
          Disclaimer: For faster and more reliable payments, please use the bank transfer option.
        </div>
        <div>
          {providersList?.length > 1 && (
            <div className="flex space-x-4 my-4">
              {providersList.map((paymentGateway, index) => (
                <Button
                  key={index}
                  onClick={() => setTabValue(index)}
                  className={`py-2 px-4 rounded-lg ${tabValue === index
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-black"
                    }`}
                >
                  {langData?.['option']} {index + 1}
                </Button>
              ))}
            </div>
          )}

          <div>
            {providersList?.length > 0 &&
              providersList.map((paymentGateway, index) =>
                renderPaymentForm(paymentGateway, index, tabValue)
              )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Deposit;